import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLenderLoanList = params => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.loan.lender_loan_list, params],
    queryFn: () =>
      loanService.lenderList(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
